<template>
  <el-container style="background: #03A9F4">
    <el-header>
      <el-row type="flex" justify="space-between">
        <el-col :span="8">
          <span style="font-size: 24px;line-height: 60px;font-family: 思源雅黑,微软雅黑;color: #FFF;">全国民办高校学生信息公共查询平台</span>
        </el-col>
        <el-col :span="1">
          <el-dropdown >
            <span class="el-dropdown-link" style="color: #FFF; line-height: 60px;cursor: pointer;">
              {{adminInfo.admin ? adminInfo.admin.name : "..."}}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
          <el-dropdown-menu slot="dropdown" >
            <el-dropdown-item @click.native="logout">安全退出</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        </el-col>
      </el-row>
    </el-header>
    <el-aside style="width:240px;">
      <el-menu :router="true" :default-active="$route.path">
        <el-submenu index="1" :active="true">
          <template slot="title">
            <i class="el-icon-location"></i>
            <span>管理员管理</span>
          </template>
          <el-menu-item-group title="管理员">
            <el-menu-item index="/admin">
              管理员列表
            </el-menu-item>
            <el-menu-item index="/admin/create">
              管理员添加
            </el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group title="权限">
            <el-menu-item index="/roles/">用户组列表</el-menu-item>
            <el-menu-item index="/roles/create">新建用户组</el-menu-item>
          </el-menu-item-group>
        </el-submenu>

        <el-submenu index="2" :active="false">
          <template slot="title">
            <i class="el-icon-location"></i>
            <span>资讯管理</span>
          </template>
          <el-menu-item-group title="分类">
            <el-menu-item index="/cate/create">分类添加</el-menu-item>
            <el-menu-item index="/cate">分类列表</el-menu-item>
          </el-menu-item-group>

          <el-menu-item-group title="文章">
            <el-menu-item index="/articles/create">文章添加</el-menu-item>
            <el-menu-item index="/articles">文章列表</el-menu-item>
          </el-menu-item-group>
        </el-submenu>

        <el-submenu index="3" :active="false">
          <template slot="title">
            <i class="el-icon-location"></i>
            <span>学生管理</span>
          </template>
          <el-menu-item index="/user_detail/create">录入</el-menu-item>
          <el-menu-item index="/">列表</el-menu-item>
          <el-menu-item index="/zip_job">zip上传</el-menu-item>
        </el-submenu>

        <el-submenu index="4" :active="false">
          <template slot="title">
            <i class="el-icon-location"></i>
            <span>网站设置</span>
          </template>
          <el-menu-item-group title="banner图">
            <el-menu-item index="/banner">Banner列表</el-menu-item>
            <el-menu-item index="/banner/create">Banner添加</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group title="广告位">
            <el-menu-item index="/ad">广告列表</el-menu-item>
            <!--<el-menu-item index="/ad/create">添加广告</el-menu-item>-->
          </el-menu-item-group>
          <el-menu-item-group title="网站设置">
            <el-menu-item index="/setting">参数设置</el-menu-item>
            <el-menu-item index="/about/1">关于我们</el-menu-item>
          </el-menu-item-group>
        </el-submenu>

      </el-menu>
    </el-aside>
    <el-main>
      <router-view></router-view>
    </el-main>
  </el-container>
</template>

<script>
  import {mapState, mapActions} from 'vuex'

  export default {
    name: "Index",
    computed: {
      ...mapState({
        adminInfo: state => state.adminInfo,
      }),
    },
    methods : {
      logout(){
        this.$confirm('确定要退出吗?', '询问', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$message({
            type: 'success',
            message: '退出成功!'
          });
          this.$store.dispatch('logout');
          this.$router.push('/login')
        }).catch(() => {

        });
      },

    }
  }
</script>

<style>
  .el-header {
  }

  .el-aside {
    position: fixed;
    top: 60px;
    bottom: 0;
    left: 0;
    border-right: 1px solid #ccc;
  }

  .el-menu {
    border-right: 0;
  }

  .el-main {
    position: absolute;
    left: 230px;
    top: 60px;
    right: 0;
    bottom: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/index/Index.vue